"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tailwindPlugin = exports.themeSchema = exports.tailwindConfigPath = exports.tailwindConfig = void 0;
const tailwindConfig = require('./tailwind.config');
exports.tailwindConfig = tailwindConfig;
const { themeSchema } = require('./theme-schema');
exports.themeSchema = themeSchema;
const tailwindPlugin = require('./tailwind').default;
exports.tailwindPlugin = tailwindPlugin;
const tailwindConfigPath = 'node_modules/@hydrogen/elements.tailwind-styles/tailwind.config';
exports.tailwindConfigPath = tailwindConfigPath;
//# sourceMappingURL=index.js.map